import { resolveApiAssetUrl } from "@/lib/backend";
import type { SitePayload } from "@/lib/types";

export type MaintenanceLogoFields = {
  logo_url?: string;
  show_logo?: string | boolean;
  background_color?: string;
};

const DEFAULT_LOGO_PATH = "/static/img/logo.png";

/** Parse hex (#rgb or #rrggbb) and return true when background is dark. */
export function isDarkBackground(hex: string | undefined): boolean {
  const raw = (hex ?? "#0f172a").replace(/^#/, "").trim();
  if (!raw) return true;
  const full =
    raw.length === 3
      ? raw
          .split("")
          .map((c) => c + c)
          .join("")
      : raw.length >= 6
        ? raw.slice(0, 6)
        : "";
  if (full.length !== 6) return true;
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  if ([r, g, b].some((n) => Number.isNaN(n))) return true;
  return 0.299 * r + 0.587 * g + 0.114 * b < 140;
}

export function maintenanceShowLogo(showLogo: unknown): boolean {
  if (showLogo === false || showLogo === "false") return false;
  return true;
}

/**
 * Logo for the maintenance page: custom CMS upload/URL, then site brand logos
 * (dark variant on dark backgrounds), then default site logo asset on the API host.
 */
export function resolveMaintenanceLogoSrc(
  data: MaintenanceLogoFields,
  site?: SitePayload | null,
): string {
  const custom = String(data.logo_url ?? "").trim();
  if (custom) return resolveApiAssetUrl(custom);

  const darkBg = isDarkBackground(data.background_color);
  const fromSite = darkBg
    ? site?.logoUrlDark || site?.logoUrlLight || site?.logoUrl
    : site?.logoUrlLight || site?.logoUrlDark || site?.logoUrl;

  if (String(fromSite ?? "").trim()) {
    return resolveApiAssetUrl(fromSite);
  }

  return resolveApiAssetUrl(DEFAULT_LOGO_PATH);
}
